import { useState } from "react";
import { C } from "../../shared/theme";
import { listCard } from "../../shared/ListRow";
import { RADAR_GROUP_CAP } from "./signals";

// How a group lays out what it lists: "rows" sit on the page as the Tasks page's rows do, and goal bars stack as on
// Goals; "cards" are a stack of cards (Key Dates); "card" is one white card of rows (Habits, Dreams, Fears, as on
// their own pages, read when drawn since C changes with the theme).
const body = (layout) => (layout === "card" ? listCard() : layout === "cards" ? { display: "grid", gap: 12 } : {});

// One Radar group: its heading folds it, ⠿ moves it. A group that is off, or has nothing to list, isn't drawn.
export function RadarGroup({ off, collapsed, onToggle, icon, label, color, count, helpIcon, children, dragAttributes, dragListeners, isDragging, layout = "rows" }) {
  if (off || count === 0) return null;
  return (
    <div style={{ marginBottom: collapsed ? 10 : 18, opacity: isDragging ? 0.4 : 1 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: collapsed ? 0 : 8, userSelect: "none" }}>
        <button onClick={onToggle} aria-expanded={!collapsed}
          style={{ display: "flex", alignItems: "center", gap: 7, flex: 1, minWidth: 0, minHeight: 44, padding: 0, background: "none", border: "none", textAlign: "left", cursor: "pointer", fontFamily: "inherit" }}>
          <span aria-hidden="true" style={{ fontSize: 16 }}>{icon}</span>
          <span style={{ fontSize: 14, fontWeight: 700, color, letterSpacing: "0.05em", textTransform: "uppercase" }}>{label}</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: C.textDim }}>{count}</span>
          <span aria-hidden="true" style={{ fontSize: 12, color: C.textDim, marginLeft: 2 }}>{collapsed ? "▼" : "▲"}</span>
        </button>
        {helpIcon}
        <span {...(dragAttributes || {})} {...(dragListeners || {})}
          style={{ fontSize: 16, color: C.textDim, paddingLeft: 8, paddingRight: 2, cursor: "grab", touchAction: "none", lineHeight: 1 }}>⠿</span>
      </div>
      {!collapsed && <div style={body(layout)}>{children}</div>}
    </div>
  );
}

// The first few of a group's items (RADAR_GROUP_CAP), then "Show N more" to see the rest. renderItem(item, i) draws one.
export function CappedList({ items, renderItem }) {
  const [all, setAll] = useState(false);
  const shown = all ? items : items.slice(0, RADAR_GROUP_CAP);
  return (
    <>
      {shown.map(renderItem)}
      {items.length > RADAR_GROUP_CAP && (
        <button onClick={() => setAll(a => !a)}
          style={{ width: "100%", minHeight: 44, padding: "0 14px", background: "none", border: "none", fontSize: 16, fontWeight: 600, color: C.accent, cursor: "pointer", fontFamily: "inherit" }}>
          {all ? "Show less" : `Show ${items.length - RADAR_GROUP_CAP} more`}
        </button>
      )}
    </>
  );
}
